import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import { useQuery } from '@tanstack/react-query';
import { ReactNode } from 'react';
import { css } from 'styled-system/css';
import { Box, Grid } from 'styled-system/jsx';
import ActionsCard from '@/modules/FileDetail/components/entryTabs/Cards/ActionsCard/ActionsCard.tsx';
import AdjusterReportsCard from '@/modules/FileDetail/components/entryTabs/Cards/AdjusterReportsCard/AdjusterReportsCard';
import DocumentsCard from '@/modules/FileDetail/components/entryTabs/Cards/DocumentsCard/DocumentsCard';
import FileInformationCard from '@/modules/FileDetail/components/entryTabs/Cards/FileInformationCard/FileInformationCard';
import StatusLogCard from '@/modules/FileDetail/components/entryTabs/Cards/StatusLogCard/StatusLogCard';
import { EntryTabsQueryResponseType } from '@/modules/FileDetail/queries/entryTabs/entryTabsQuery.type.ts';
import { entryTabsQueryOptions } from '@/modules/FileDetail/queries/entryTabs/entryTabsQueryOptions.ts';
import { useParams } from 'react-router-dom';

const EntryTabs = () => {
  const { id } = useParams();

  const { data, isPending, isError } = useQuery(entryTabsQueryOptions(id!));

  if (isError) {
    return <></>;
  }

  return (
    <>
      <TitleDescription textStyle="h2" color="black-1" mt="2rem">
        دسته‌بندی‌ها
      </TitleDescription>
      {isPending ? (
        <Box display="flex" alignItems="center" justifyContent="center">
          <CircularLoading color="colors.purple-primary" />
        </Box>
      ) : (
        <Box mt="16px">
          <Grid
            className={css({
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '8px',
            })}
          >
            {data?.map((item) => (
              <Box key={item.name}>{generateEntryTabs(item)}</Box>
            ))}
          </Grid>
        </Box>
      )}
    </>
  );
};

export default EntryTabs;

const generateEntryTabs = (tab: EntryTabsQueryResponseType) => {
  const items: Record<string, ReactNode> = {
    file_information: <FileInformationCard title={tab.fa_name} />,
    adjuster_reports: <AdjusterReportsCard title={tab.fa_name} />,
    status_log: <StatusLogCard title={tab.fa_name} />,
    actions: <ActionsCard title={tab.fa_name} />,
    documents: <DocumentsCard title={tab.fa_name} />,
  };
  return items[tab.name];
};
